import { Component, OnInit } from '@angular/core';
import { ProductsBiocatchEnum, StepBiocatchEnum } from 'src/app/shared/enums/biocatchContext.enum';
import { ContactModel } from 'src/app/shared/models/contact.model';
import { DocumentModel } from 'src/app/shared/models/document.model';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { RequestService } from 'src/app/shared/services/request/request-onboarding.service';

import { OpEnum } from '../../../shared/enums/op.enum';
import { MaritalStatusModel, MaritalStatusSecondHeadlineModel } from '../../../shared/models/abre-cuentas.model';
import { AbreCuentasService } from '../../../shared/services/abre-cuentas/abre-cuentas.service';
import { CaptureService } from '../../../shared/services/capture/capture.service';
import { CopyService } from '../../../shared/services/copies/copy.service';
import { HeaderService } from '../../../shared/services/header/header.service';
import { NavigationService } from '../../../shared/services/navigation/navigation-onboarding.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';

/**
 * Configuración predeterminada del componente
 *
 * *Default component settings*
 */
@Component({
  selector: 'app-marital-status',
  templateUrl: './marital-status.component.html',
  styleUrls: ['./marital-status.component.scss'],
})

/**
 * Clase de componente MaritalStatusComponent
 *
 * *MaritalStatusComponent class component*
 *
 * @implements {OnInit}
 */
export class MaritalStatusComponent implements OnInit {

  options: [any];
  selectedMaritalStatus: MaritalStatusModel;
  selectSecondHeadMaritalStatus: MaritalStatusSecondHeadlineModel;
  validButton = true;
  has_second_headline: any;
  contactInfo: any;
  documentInfo: DocumentModel;
  constructor(
    public copyService: CopyService,
    private headerService: HeaderService,
    private captureService: CaptureService,
    private navigationService: NavigationService,
    private abreCuentasService: AbreCuentasService,
    private parametersService: ParametersService,
    private requestService: RequestService,
    private bitacoraService: BitacoraService,
    private bioCatchService: BioCatchService) {
    this.headerService.show(true, true, true);

  }

  ngOnInit() {
    this.initBioCatch();
    this.documentInfo = this.abreCuentasService.getDocumentInfo();
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    if (product === ProductsBiocatchEnum.TCR) {
      this.bioCatchService.changeContext(StepBiocatchEnum.captura, product, false, true);
    }
    this.has_second_headline = this.abreCuentasService.getSecondHeadline();
    this.options = this.parametersService.getSetting(OpEnum.CIVIL_STATUS_LIST);
    const selectedMaritalStatus = (this.has_second_headline) ? this.abreCuentasService.getMaritalStatusSecondHeadLine()
    : this.abreCuentasService.getMaritalStatusInfo();
    if (!!selectedMaritalStatus && selectedMaritalStatus.marital_status_code) {
      this.selectedMaritalStatus = (this.has_second_headline) ? this.abreCuentasService.getMaritalStatusSecondHeadLine()
      : this.abreCuentasService.getMaritalStatusInfo();
    } else {
      this.selectedMaritalStatus = { marital_status_code: 0, marital_status_description: '' };
    }
  }

  /**
   * Summary Go to next Step
   */
  next() {
    console.log('identification - NextStep()');
   /*  const bitacoraEvent = 'fingersPrintScan_succes';
    this.bitacoraService.saveDataInBitacora(bitacoraEvent); */
    this.navigationService.nextStep('200');
  }

  /**
   * Summary Event for select a option for list selected, and set value in Input
   * @param option
   */
  selectOption(event) {
    if (event.value) {
      this.selectedMaritalStatus.marital_status_code = event.value.id;
      this.selectedMaritalStatus.marital_status_description = event.value.value;
      (this.has_second_headline) ? this.abreCuentasService.setMaritalStatusSecondHeadline(this.selectedMaritalStatus)
      : this.abreCuentasService.setMaritalStatusInfo(this.selectedMaritalStatus);
      this.validButton = false;
    } else {
      this.selectedMaritalStatus = { marital_status_code: 0, marital_status_description: '' };
      this.validButton = true;
    }
    (this.has_second_headline) ? this.abreCuentasService.getMaritalStatusSecondHeadLine()
    : this.abreCuentasService.getMaritalStatusInfo() ;
  }
  initBioCatch() {
    const product = this.abreCuentasService.getproductSelected().product_code as ProductsBiocatchEnum;
    this.bioCatchService.changeContext(StepBiocatchEnum.captura, product);
  }

}
